export const permissionKeys = {
  list: () => ['permissions'] as const,
}
